export { default as bootStrapWebPushService } from './bootstrapWebPushService';
